<template>
  <div>
    <section v-for="(item, index) in extras" :key="index">
      <div class="flex w-full mt-5">
        <div class="w-8/12">
          <h5 class="font-bold mb-3">{{ item.Description }}</h5>
          <p class="my-3">RM {{ item.Charge.toFixed(2) }} {{ label }}</p>
          <p class="mt-3">{{ item.AdditionalInfo }}</p>
        </div>
        <div class="w-4/12 flex items-center my-auto">

          <template v-if="item.Code == 'BOST' || item.Code == 'BSEAT'">
            <vs-input-number v-model="item.Quantity" :max="2" :min="0" />
          </template>
          <template v-else-if="['PAI', 'ADDRV'].includes(item.Code)">
            <vs-switch color="success" :value="item.Quantity === 1" @input="val => item.Quantity = val ? 1 : 0" />
          </template>
          <template v-else-if="['CDW', 'SCDW',].includes(item.Code)">
            <div class="flex w-full mt-5 gap-x-4">
              <vs-switch color="success" :value="item.Quantity === 1" @input="toggleExclusive(item.Code)" />
            </div>

          </template>
          <template v-else>
            <vs-input-number v-model="item.Quantity" />
          </template>

        </div>
      </div>
      <vs-divider />
    </section>
  </div>
</template>

<script>
export default {
  props: {
    filter: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      default: 'each per rental'
    }
  },
  computed: {
    extras() {
      //return extras base on filter
      return this.$store.state.main.extras.filter(extra => this.filter.includes(extra.Code));
    }
  },
  methods: {

    getMatchingItem(code) {
      return this.$store.state.main.reservationData.Extras.find(item => item.Code === code);
    },
    updateQuantities() {

      //check if extras is not undefined
      if (!this.$store.state.main.extras) {
        return;
      }

      const extras = this.$store.state.main.extras;
      const reservationExtras = this.$store.state.main.reservationData.Extras;

      extras.forEach(extra => {
        const match = reservationExtras.find(resExtra => resExtra.Code === extra.Code);
        if (match) {
          extra.Quantity = match.Quantity;
        }
      });


    },
    toggleExclusive(selectedCode) {
      this.extras.forEach(extra => {
        if (['CDW', 'SCDW'].includes(extra.Code)) {
          if (extra.Code === selectedCode) {
            // Toggle the selected item: If it's already 1, set it to 0; otherwise, set it to 1
            extra.Quantity = extra.Quantity === 1 ? 0 : 1;
          } else {
            // Ensure the other option is set to 0
            extra.Quantity = 0;
          }
        }
      });
    }
  },
  created() {
    this.updateQuantities();
  }
};
</script>

<style scoped></style>
